export const isRowSelected = (id: string | number | undefined | null, selectedResources: string[]) => {
  return !!id && selectedResources.includes(String(id));
};
